:host {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.quick-reply {
  &__text {
    display: flex;
    height: 100%;
    padding: 8px 16px;
    background-color: var(--message-robot-background-color);
    color: var(--message-robot-color);
  }

  &__buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    padding: 0 40px;

    rasa-text::part(text) {
      width: calc(100%);
      max-width: 250px;
      text-overflow: ellipsis;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
    }

    &--disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }
}
